import { NgModule } from '@angular/core';
import { InfoComponent, InfoTooltipComponent } from './info.component';

import { MaterialsModule } from '@library/common/materials';

@NgModule({
  declarations: [
    InfoComponent, 
    InfoTooltipComponent
  ],
  imports: [
     MaterialsModule,
  ],
  exports: [ InfoComponent ]
})
export class InfoModule { }
